import { Link } from "react-router-dom";
import { Layers, Tags, Boxes, LayoutDashboard } from "lucide-react";

/**
 * BottomNav — quick jumps between the primary screens. Shown at the bottom
 * of each screen with the *current* one omitted so the user always sees the
 * other destinations.
 *
 * Props:
 *   current: "dashboard" | "collections" | "categories" | "items"
 */
const ALL = [
  { key: "dashboard",   label: "Go to Dashboard",   to: "/dashboard",   Icon: LayoutDashboard, testid: "bottom-go-dashboard"   },
  { key: "collections", label: "Go to Collections", to: "/collections", Icon: Layers,          testid: "bottom-go-collections" },
  { key: "categories",  label: "Go to Categories",  to: "/categories",  Icon: Tags,            testid: "bottom-go-categories"  },
  { key: "items",       label: "Go to Items",       to: "/items",       Icon: Boxes,           testid: "bottom-go-items"       },
];

export default function BottomNav({ current }) {
  const links = ALL.filter((l) => l.key !== current);
  return (
    <nav
      data-testid="bottom-nav"
      className="mt-16 pt-8 border-t border-[hsl(var(--border))] flex flex-wrap gap-3 justify-center"
      aria-label="Quick navigation"
    >
      {links.map(({ to, label, Icon, testid }) => (
        <Link
          key={to}
          to={to}
          data-testid={testid}
          className="vp-btn vp-btn-secondary"
        >
          <Icon size={15} /> {label}
        </Link>
      ))}
    </nav>
  );
}
